<script setup lang="ts">
import UIBody from '@/components/ui/UIBody.vue'
import UIHeading from '@/components/ui/UIHeading.vue'
import { ITitleDescriptionItem } from '@lifk/types'

defineProps<{
  titleDescription: ITitleDescriptionItem
}>()
</script>
<template>
  <div data-testid="references-tooltip" class="w-[283px] py-2">
    <UIHeading
      variant="serif"
      tag="h4"
      :text="titleDescription.title"
      style="text-wrap: wrap"
    ></UIHeading>
    <UIBody weight="regular" class="whitespace-normal">
      <p class="pt-[5px]">
        {{ titleDescription.description }}
      </p>
    </UIBody>
  </div>
</template>
